export const PER_KEY = 'PER_KEY'
export const GOOD_INFO = 'GOOD_INFO'